import { render, staticRenderFns } from "./ExpensesPage.vue?vue&type=template&id=552e7e6f&"
import script from "./ExpensesPage.ts?vue&type=script&lang=js&"
export * from "./ExpensesPage.ts?vue&type=script&lang=js&"
import style0 from "./ExpensesPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports